// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"BottomText_Wrapper__1xmmw","TextBlack":"BottomText_TextBlack__neSsu","TextOrange":"BottomText_TextOrange__2j47k","BorderLine":"BottomText_BorderLine__1OUak"};